var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnrollInAutopay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5.5,
    width: 13,
    height: 10,
    fill: "#E1E0E9",
    stroke: "#E1E0E9",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 13,
    height: 3,
    fill: "#A483B0",
    stroke: "#63768D",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 1.5,
    width: 2,
    height: 1,
    fill: "#A483B0",
    stroke: "#63768D",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1.5,
    width: 2,
    height: 1,
    fill: "#A483B0",
    stroke: "#63768D",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.5L2 15.5L2 5.5",
    stroke: "#63768D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H9M4 10.5H7.5M4 13H7",
    stroke: "#63768D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3482 19.7747L11.834 17.3281L14.0387 16.1494",
    stroke: "#63768D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6292 6.86549L18.1434 9.31203L15.9387 10.4907",
    stroke: "#63768D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97271 15.8335C10.12 16.1303 10.4801 16.2515 10.7769 16.1041C11.0737 15.9568 11.1949 15.5967 11.0476 15.2999L9.97271 15.8335ZM20.0048 10.848C19.8574 10.5512 19.4974 10.43 19.2006 10.5774C18.9038 10.7247 18.7826 11.0848 18.9299 11.3816L20.0048 10.848ZM18.3593 16.169C16.7973 18.0305 14.022 18.2734 12.1605 16.7113L11.3891 17.6306C13.7583 19.6186 17.2906 19.3096 19.2786 16.9404L18.3593 16.169ZM11.6181 10.5125C13.1802 8.65095 15.9555 8.40814 17.817 9.97015L18.5884 9.0509C16.2191 7.06289 12.6869 7.37192 10.6989 9.74114L11.6181 10.5125ZM11.0476 15.2999C10.293 13.7797 10.459 11.8939 11.6181 10.5125L10.6989 9.74114C9.22222 11.501 9.01368 13.9014 9.97271 15.8335L11.0476 15.2999ZM18.9299 11.3816C19.6845 12.9018 19.5185 14.7876 18.3593 16.169L19.2786 16.9404C20.7553 15.1805 20.9638 12.7801 20.0048 10.848L18.9299 11.3816Z",
    fill: "#63768D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollInAutopay);
export default __webpack_public_path__ + "static/media/enroll-in-autopay.58aee7ef.svg";
export { ForwardRef as ReactComponent };